import {
  OCCUPATION_PREVIEW,
  OCCUPATION_NEW,
  OCCUPATION_UPDATE,
  OCCUPATION_REMOVE,
  OCCUPATION_PROCESS_SUCCESS,
  OCCUPATION_DATASOURCE_SUCCESS,
  OCCUPATION_SEARCH,
  OCCUPATION_PROCESS_RESET
} from "constants/ActionTypes"

const INIT_STATE = {
  loader: false,
  dataSerialize:{},
  dataSource:[],
  process:{},
  keyword:''
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case OCCUPATION_PREVIEW: {
      return {
        ...state,
        loader: false,
        process:{status:false,action:"",message:""}
      }
    }
    case OCCUPATION_NEW: {
      return {
          ...state,
          loader: true,
          process:{status:false,action:"",message:""}
      }
    }
    case OCCUPATION_UPDATE:{
        return{
          ...state,
          loader:true,
          process:{status:false,action:"",message:""},
          dataSerialize:action.payload
        }
    }
    case OCCUPATION_REMOVE: {
      return {
          ...state,
          loader: false,
          process:{status:false,action:"",message:""}
      }
    }
    case OCCUPATION_SEARCH:{
        return {
            ...state,
            loader:false,
            keyword:action.payload
        }
    }
    case OCCUPATION_PROCESS_SUCCESS:{
      return{
        ...state,
        loader:false,
        process:action.payload
      }
    }
    case OCCUPATION_DATASOURCE_SUCCESS:{
        return {
            ...state,
            loader: false,
            dataSource: action.payload
        }
    }
    case OCCUPATION_PROCESS_RESET:{
      return{
        ...state,
        process:{}
      }
    }
    default:
      return state
  }
}